import { render, staticRenderFns } from "./ClientFilters.vue?vue&type=template&id=11a72503"
import script from "./ClientFilters.vue?vue&type=script&lang=js"
export * from "./ClientFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports